import { FC, useLayoutEffect } from 'react';
import * as am5 from '@amcharts/amcharts5';
import * as am5flow from '@amcharts/amcharts5/flow';
import am5themes_Animated from '@amcharts/amcharts5/themes/Animated';
import Cookies from 'js-cookie'

type TraceableSankyDiagramProps = {
    name: string,
    data: any,
    fromField: string,
    toField: string,
    valueField: string
};

const TraceableSankyDiagram: FC<TraceableSankyDiagramProps> = ({ name, data, fromField, toField, valueField }) => {

    const chartId = name + Date.now().toString().substr(-4)
    
    useLayoutEffect(() => {

        am5.ready(function () {
            am5.addLicense('AM5M326788873');

            // Create root element
            // https://www.amcharts.com/docs/v5/getting-started/#Root_element
            var root = am5.Root.new(chartId);

            // Set themes
            // https://www.amcharts.com/docs/v5/concepts/themes/
            const defaultTheme = am5.Theme.new(root);
            root.setThemes([am5themes_Animated.new(root), defaultTheme]);

            defaultTheme.rule("ColorSet").set("colors", [
                am5.color(0x003b5c),
                am5.color(0x035684),
                am5.color(0x036eaa),
                am5.color(0x0486cf),
                am5.color(0x00293f),
                am5.color(0x118ab2),
                am5.color(0x253948),
                am5.color(0x385870),
                am5.color(0x487292),
                am5.color(0x5686aa),
                am5.color(0x073b4c),
                am5.color(0x71afde),
            ]);

            // Create series
            // https://www.amcharts.com/docs/v5/charts/flow-charts/
            var series = root.container.children.push(
                am5flow.Sankey.new(root, {
                    sourceIdField: fromField,
                    targetIdField: toField,
                    valueField: valueField,
                    paddingRight: 125,
                })
            );

            series.nodes.labels.template.setAll({
                fontSize: 12,
                maxWidth: 130,
                oversizedBehavior: 'wrap',
                fill: (Cookies.get('darkMode') === "true") ? am5.color(0xd9d9d9) : am5.color(0x003b5c),
            });

            series.links.template.setAll({
                fillStyle: "solid",
                fillOpacity: 0.15,
                fill: (Cookies.get('darkMode') === "true") ? am5.color(0xd9d9d9) : am5.color(0x003b5c),
            });


            // Set data
            const adjustedData = data.map((value: any) => {
                const tempValue = { ...value };
                tempValue[fromField] = " " + tempValue[fromField];
                tempValue[toField] = tempValue[toField] + " ";
                return tempValue;
            });

            series.data.setAll(adjustedData);

            // Make stuff animate on load
            series.appear(1000, 100);
        });
    }, []);// eslint-disable-line

    return <div id={chartId} className="chart-container" style={{ height: 1000 }} />;
};

export default TraceableSankyDiagram;
